import React from "react";
import { getFileAttachmentIconData } from "../../../../common/utils/FileAttachmentIconManager";
const AttachmentIcon = props => {
  // eslint-disable-line @typescript-eslint/no-explicit-any
  return /*#__PURE__*/React.createElement("div", {
    id: props.id,
    style: props.style
  }, /*#__PURE__*/React.createElement("img", {
    src: props.src ?? getFileAttachmentIconData("txt"),
    alt: "attachment icon"
  }));
};
export default AttachmentIcon;